var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeroHeader',{attrs:{"titles":_vm.titles}}),_c('v-container',{staticClass:"default-padding",attrs:{"fluid":""}},[_c('v-row',{staticClass:"justify-space-between"},[_c('UnitConverter')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }